import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedDataService } from 'ngx-paf-common';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';

@Component({
  selector: 'logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(
    private msalService: MsalService,
    private router: Router,
    private sharedDataSvc:SharedDataService) { }

  ngOnInit(): void {
    if (this.msalService.instance.getAllAccounts().length > 0) {
    this.msalService.logoutRedirect();
    } else {
      this.router.navigate(['/loggedout']);
    }
  }

}
